import { sideMenuActions } from '@/modules/layout/composables/useSideMenu/sideMenuDefinition/sideMenuActions.ts'
import { sideMenuConfig } from '@/modules/layout/composables/useSideMenu/sideMenuDefinition/sideMenuConfig.ts'
import type { SideMenuItem } from '@/modules/layout/composables/useSideMenu/SideMenuItem.ts'

export const sideMenuDefinition: {
  actions: SideMenuItem[]
  config: SideMenuItem[]
} = {
  actions: sideMenuActions,
  config: sideMenuConfig
}
